export default {
	TEMPLATE_MANAGER: 'companies/:company_id/communication/',
}